// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import GlobalStyles from './styles/GlobalStyles';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import SongPage from './pages/SongPage';
import CollectionPage from './pages/CollectionPage';
import FeaturedPage from './pages/FeaturedPage';
import SearchResultsPage from './pages/SearchResultsPage';
import Login from './pages/Login';
import UserPage from './pages/UserPage';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import { SongProvider } from './SongContext';
import PrivateRoute from './components/PrivateRoute';
import TOS from './pages/TOS';
import PrivacyPolicy from './pages/PrivacyPolicy';
import PricingPage from './pages/PricingPage';
import NotFoundPage from './pages/NotFoundPage';
import RadioPage from './pages/RadioPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import CollectionsPage from './pages/CollectionsPage';
import { IntercomProvider } from './components/IntercomProvider';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <SongProvider>
        <IntercomProvider>
          <GlobalStyles />
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/songs/:songId" element={<SongPage />} />
              <Route path="/:category" element={<CollectionPage />} />
              <Route path="/featured" element={<FeaturedPage />} />
              <Route path="/radio" element={<RadioPage />} />
              <Route path="/collections" element={<CollectionsPage />} />
              <Route path="/search" element={<SearchResultsPage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:postId" element={<BlogPostPage />} />
              <Route
                path="/user"
                element={
                  <PrivateRoute>
                    <UserPage />
                  </PrivateRoute>
                }
              />
              <Route path="/tos" element={<TOS />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Layout>
        </IntercomProvider>
      </SongProvider>
    </Router>
  );
}

export default App;